import CloseRounded from "@mui/icons-material/CloseRounded";
import FormControl from "@mui/joy/FormControl";
import IconButton from "@mui/joy/IconButton";
import Option from "@mui/joy/Option";
import Select, { SelectStaticProps } from "@mui/joy/Select";
import Stack from "@mui/joy/Stack";
import React from "react";
import { ValidationState } from "../../../models/note";
import { Coding } from "../../../models/structuration";
import { useValuesetCodings } from "../../../shared/hooks/useValuesetCodings";
import { SearchBar } from "../../../shared/components/search/SearchBar";

interface NoteFiltersProps {
  readonly defaultStatus: ValidationState;
  readonly defaultNoteType: string | null;
  readonly searchByCoding: Coding | null;
  readonly onStatusChange: (status: ValidationState) => void;
  readonly onNoteTypeChange: (noteType: string | null) => void;
  readonly onSearch: (coding: Coding | null) => void;
}

export default function NoteFilters({
  defaultStatus,
  defaultNoteType,
  searchByCoding,
  onStatusChange,
  onNoteTypeChange,
  onSearch,
}: NoteFiltersProps) {
  const { codings: documentTypes } = useValuesetCodings("document-type");
  const status = defaultStatus !== "all" ? defaultStatus : null;
  const actionNoteType: SelectStaticProps["action"] = React.useRef(null);
  const actionStatus: SelectStaticProps["action"] = React.useRef(null);

  return (
    <Stack direction="row" spacing={2}>
      <FormControl sx={{ width: "60%" }}>
        {/* <FormLabel id="search-bar" htmlFor="search-bar">
          Search
        </FormLabel> */}
        <SearchBar
          message="Search a fact among the notes"
          onChange={onSearch}
          isSmall
          coding={searchByCoding}
        />
      </FormControl>
      <FormControl sx={{ width: "20%" }}>
        {/* <FormLabel id="select-field-note-type" htmlFor="select-field-note-type">
          Note type
        </FormLabel> */}
        <Select
          placeholder="Filter on note type"
          defaultValue={defaultNoteType}
          onChange={(e, newValue) => onNoteTypeChange(newValue)}
          {...(defaultNoteType && {
            endDecorator: (
              <IconButton
                size="sm"
                variant="plain"
                color="neutral"
                onMouseDown={(event) => {
                  event.stopPropagation();
                }}
                onClick={() => {
                  onNoteTypeChange(null);
                  actionNoteType.current?.focusVisible();
                }}
              >
                <CloseRounded fontSize="small" />
              </IconButton>
            ),
            indicator: null,
          })}
        >
          {documentTypes.map((type) => (
            <Option key={type.code} value={type.code}>
              {type.display}
            </Option>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ width: "20%" }}>
        {/* <FormLabel id="select-field-status" htmlFor="select-field-status">
          Status
        </FormLabel> */}
        <Select
          placeholder="Filter on status"
          defaultValue={status}
          onChange={(e, newValue) => onStatusChange(newValue || "all")}
          {...(status && {
            endDecorator: (
              <IconButton
                size="sm"
                variant="plain"
                color="neutral"
                onMouseDown={(event) => {
                  event.stopPropagation();
                }}
                onClick={() => {
                  onStatusChange("all");
                  actionStatus.current?.focusVisible();
                }}
              >
                <CloseRounded />
              </IconButton>
            ),
            indicator: null,
          })}
        >
          <Option value="validated-only">Verified</Option>
          <Option value="unvalidated-only">Unverified</Option>
        </Select>
      </FormControl>
    </Stack>
  );
}
